import { css } from "@emotion/react";
import { contentCss } from "./content.css";
import scrollCss from "./scroll.css";

export const modalContainerCss = [
  contentCss,
  css`
    position: relative;
    max-width: 459px;
    box-sizing: border-box;
  `,
];

export const modalBodyCss = [
  scrollCss,
  css`
    max-height: 438px;
    padding: 0 8px;
    overflow-y: auto;
  `,
];

export const modalFooterCss = css`
  padding: 20px 8px 0;
`;

export const closeButtonCss = css`
  position: absolute;
  top: 8px;
  right: 8px;
`;
